import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import './App.css';

function PrivacyPolicy() {
  return (
    <div className="App">
      <Navigation />
      
      <header className="App-header">
        <div className="page-content">
          <h1>Privacy Policy</h1>
          
          <div className="legal-content">
            <p><strong>Last updated:</strong> October 28, 2025</p>
            
            <section className="legal-section">
              <h2>1. Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you create an account, make a reservation, contact us, or use our services. This may include:</p>
              <ul>
                <li>Personal information (name, email address, phone number)</li>
                <li>Payment information (credit card details, billing address)</li>
                <li>Reservation details (dates, vehicle preferences, special requests)</li>
                <li>Communication records with our customer service</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Process and manage your reservations</li>
                <li>Communicate with you about your bookings</li>
                <li>Provide customer support</li>
                <li>Send you promotional materials (with your consent)</li>
                <li>Improve our services and website functionality</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>3. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties except:</p>
              <ul>
                <li>With your explicit consent</li>
                <li>To service providers who assist us in operating our business</li>
                <li>When required by law or to protect our rights</li>
                <li>In connection with a business transaction (merger, acquisition, etc.)</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>4. Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
            </section>

            <section className="legal-section">
              <h2>5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access and update your personal information</li>
                <li>Request deletion of your data (subject to legal requirements)</li>
                <li>Opt out of marketing communications</li>
                <li>Request a copy of your data</li>
              </ul>
            </section>

            <section className="legal-section">
              <h2>6. Cookies</h2>
              <p>We use cookies and similar technologies to enhance your browsing experience, analyze website traffic, and personalize content. You can control cookie settings through your browser preferences.</p>
            </section>

            <section className="legal-section">
              <h2>7. Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at:</p>
              <p>
                <strong>BlobCity iSolutions Pvt Ltd</strong><br />
                Email: hello@vidaai.com<br />
                BlobCity c/o WeWork Enam Sambhav, C20, G Block<br />
                BKC, Bandra East, Mumbai, Maharashtra 400051. India.
              </p>
            </section>
          </div>
        </div>
      </header>
      
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
